import { useEffect, useState } from "react";
import styles from './HoverContainer.styles';

export default function HoverContainer({ 
    children, 
    style, 
    hoverColor, 
    onMouseHoverCb = (isMouseHovering) => {},
    ...rest }) {
    const [isMouseHovering, setIsMouseHovering] = useState(false);

    // Setting useEffect because JS will throw the warning otherwise.
    // useEffect will help call the function after rendering of this
    // component completed. Else, the function will call and change
    // the state of parent while rendering this component. That will be wrong in terms of flow.
    useEffect(() => {
        onMouseHoverCb(isMouseHovering);
    }, [isMouseHovering])
    

    return <div 
        style={{
            ...styles.container,
            ...style,
            ...(isMouseHovering?{backgroundColor: hoverColor}:{})
            }} 
        onMouseEnter={() => setIsMouseHovering(true)} 
        onMouseLeave={() => setIsMouseHovering(false)} 
        {...rest} >
            {children}
    </div>

}